import { FormInstance, notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { createCarrier } from './api'

const useCreateCarrier = (onClose: () => void, form: FormInstance<any>) => {
  const { t } = useTranslation()

  const queryClient = useQueryClient()

  const onCreateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.CARRIERS_ADMIN)
    onClose()
  }

  const { mutate, isLoading: isLoadingCarrier } = useMutation(createCarrier, {
    onSuccess: () => {
      notification.success({
        message: t('notifications_carriers.new_carrier_created_successfully'),
      })
      onCreateSuccess()
    },
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data?.error as {
        type: string
        status: number
        message: string
      }

      if (!errorResponse) {
        notification.error({
          message: t('notifications_carriers.error_carrier_could_not_be_created'),
        })
        return
      }

      const namesByType = {
        EMAIL_ALREADY_EXISTS: 'email',
        SAP_CODE_ALREADY_EXISTING: 'sapId',
        NAME_ALREADY_EXISTING: 'tradeName',
      }

      let translatedMessage

      if (Object.keys(namesByType).includes(errorResponse.message)) {
        translatedMessage = t(`notifications_carriers.${errorResponse.message}`)
        form.setFields([
          {
            name: namesByType[errorResponse.message as keyof typeof namesByType],
            errors: [translatedMessage],
          },
        ])
      } else {
        translatedMessage = t('notifications_carriers.error_carrier_could_not_be_created')
      }

      notification.error({
        message: translatedMessage,
      })
    },
  })

  return {
    createCarrier: mutate,
    isLoadingCarrier,
  }
}

export default useCreateCarrier
